<template>
  <div v-if="venueCampaign">
    <vx-card no-shadow>
      <div class="flex">
        <div class="flex-grow flex-shrink-1 pr-4">
          <h2 class="mt-4">NightPay Push Notification</h2>
          <h5 class="my-5" v-if="!isEditable">
            <b>Note: Cannot be saved as campaign has status {{ statusObject(venueCampaign.status).text }}.</b>
          </h5>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification title</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-textarea
                  label="This cannot be changed."
                  placeholder="<venue_name>"
                  disabled="true"
                  v-model="venueCampaign.npPushInfo.title"
                  height="80px"
                  class="pushContentContainer"
                  ref="textareaTitle"
                  counter="65"
                />
                <!-- <vs-chip
                  class="cursor-pointer"
                  @click.native="addHandlebar(item.handlebar, 'Title')"
                  v-for="item in handlebars"
                  :key="item.handlebar"
                >
                  <b>{{ item.name }}</b>
                </vs-chip> -->
              </div>
            </div>
          </div>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification body</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-textarea
                  label=""
                  v-model="venueCampaign.npPushInfo.body"
                  height="160px"
                  class="pushContentContainer"
                  ref="textareaBody"
                  counter="178"
                />
                <vs-chip
                  class="cursor-pointer"
                  @click.native="addHandlebar(item.handlebar, 'Body')"
                  v-for="item in handlebars"
                  :key="item.handlebar"
                >
                  <b>{{ item.name }}</b>
                </vs-chip>
              </div>
            </div>
          </div>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification CTA name</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-input
                  label=""
                  v-model="venueCampaign.npPushInfo.ctaName"
                  height="160px"
                  class="pushContentContainer w-full mb-2"
                  ref="npInfoCtaName"
                />
              </div>
            </div>
          </div>

          <div class="col-8 mb-5">
            <h4 class="my-2">Notification CTA url</h4>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-4/5 max-w-lg">
                <vs-input
                  label=""
                  v-model="venueCampaign.npPushInfo.ctaUrl"
                  height="160px"
                  class="pushContentContainer w-full mb-2"
                  ref="npInfoCtaName"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="flex justify-end flex-shrink-0">
          <div class="mt-8">
            <vx-card class="max-w-md">
              <h5 class="mb-1">Checklist</h5>
              <div class="mb-3 pr-3">
                The push notification must contain the following:
              </div>

              <div class="ml-2">
                <vs-row>
                  <feather-icon
                    :icon="
                      requiredTags.unsub_phrase
                        ? 'CheckSquareIcon'
                        : 'SquareIcon'
                    "
                    class="inline-block mr-2"
                    svgClasses="w-6 h-6"
                  />
                  <span
                    class="font-bold"
                    :class="{ 'line-through': requiredTags.unsub_phrase }"
                    >Unsub phrase</span
                  >
                </vs-row>
              </div>
              <vs-progress
                :height="8"
                :percent="requiredTags.progress"
                class="mt-2"
                color="#24c1a0"
                >success</vs-progress
              >
            </vx-card>
          </div>
        </div> -->
      </div>
      <!-- Save & Remove Button -->
      <vs-row
        vs-justify="flex-end"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
        v-if="hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')"
      >
        <!-- <vs-button v-if="isEditable" @click="onClickSendTest" class="mt-2"
          >Send test</vs-button
        > -->
        <vs-button v-if="isEditable" id="save-button" @click="$emit('onSave')" class="mt-2 ml-4">Save Changes</vs-button>
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  props: ["venueCampaign", "isEditable"],
  mixins: [campaignMixin],
  computed: {
    handlebars() {
      return this.$store.getters["handlebars/getFor"]("guest", "venue", "sendDate")
        .filter(e => e.handlebar != "venue_openhours" && e.handlebar != "venue_openhours_html")
        .map(e => {
          return {
            handlebar: `{{${e.handlebar}}}`,
            name: e.name,
            description: e.description
          };
        });
    },
    requiredTags() {
      const result = {
        unsub_phrase: this.venueCampaign.smsContent.includes("{{venue_sms_unsub_phrase}}")
      };

      return {
        ...result,
        progress: (_.chain(result).values().sum().value() / _.values(result).length) * 100,
        isValid: _.chain(result).values().every().value()
      };
    }
  },
  methods: {
    addHandlebar(handlebar, refPostfix) {
      const el = this.$refs["textarea" + refPostfix].$el.children[0];
      const [start, end] = [el.selectionStart, el.selectionEnd];
      el.setRangeText(handlebar, start, end, "select");
      if (refPostfix == "Title") {
        this.venueCampaign.npPushInfo.title = el.value;
      } else {
        this.venueCampaign.npPushInfo.body = el.value;
      }
    }
  }
};
</script>


<style lang="scss">
.pushContentContainer textarea {
  height: 100%;
}
</style>